import { Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { AccessGuard } from './shared/guard/access.guard';
import { AppAuthGuard } from './shared/guard/app-auth.guard';
import { SoffLogMessagePermission, SoffWorkOrderPermission } from './shared/models/account/auth.model.sto';
import { DsmLicenseEnum } from './shared/models/account/workshop.sto';

export const routes: Routes = [
  { path: '', redirectTo: 'app', pathMatch: 'full' },

  {
    path: 'app/account/session/login',
    component: OktaCallbackComponent,
  },

  { path: 'app/account', loadChildren: () => import('./features/account/account.routes').then(m => m.ACCOUNT_ROUTES) },

  // Disclaimer
  {
    path: 'legal/terms-of-use',
    loadChildren: () => import('./features/legal-terms-of-use/terms-of-use.routes').then(m => m.LEGAL_TERMS_OF_USE_ROUTES),
  },

  // Privacy
  {
    path: 'legal/privacy',
    loadChildren: () => import('./features/legal-privacy/privacy.routes').then(m => m.LEGAL_PRIVACY_ROUTES),
  },

  {
    path: 'app',
    canActivateChild: [AppAuthGuard],
    children: [
      { path: '', redirectTo: 'incoming-topics', pathMatch: 'full' },

      // Feature: customers
      {
        path: 'customers',
        loadChildren: () => import('./features/customers/customers.routes').then(m => m.CUSTOMER_ROUTES),
      },

      // Feature: employees
      {
        path: 'employees',
        loadChildren: () => import('./features/employees/employees.routes').then(m => m.EMPLOYEE_ROUTES),
        canActivateChild: [AccessGuard],
        data: {
          dsmLicenseNeeded: [DsmLicenseEnum.PLUS, DsmLicenseEnum.PRO],
          permissionNeeded: [SoffWorkOrderPermission.WORKORDER_CREATE], // only usable for Foremen
          isProductionReady: true,
        },
      },

      // Feature: incoming-topics
      {
        path: 'incoming-topics',
        loadChildren: () => import('./features/incoming-topics/incoming-topics.routes').then(m => m.INCOMINGTOPICS_ROUTES),
      },

      // Feature: field-service
      {
        path: 'field-service',
        loadChildren: () => import('./features/field-service/field-service.routes').then(m => m.FIELDSERVICE_ROUTES),
        canActivateChild: [AccessGuard],
        data: {
          dsmLicenseNeeded: [DsmLicenseEnum.PLUS, DsmLicenseEnum.PRO],
          permissionNeeded: [SoffWorkOrderPermission.WORKORDER_CREATE], // only usable for Foremen
          isProductionReady: true,
        },
      },

      // Feature: machine
      {
        path: 'machines',
        loadChildren: () => import('./features/machines/machines.routes').then(m => m.MACHINES_ROUTES),
        canActivateChild: [AppAuthGuard],
      },

      // Feature: search
      {
        path: 'search',
        loadChildren: () => import('./features/search/search.routes').then(m => m.SEARCH_ROUTES),
        canActivateChild: [AppAuthGuard],
      },

      // Feature: servicevan
      {
        path: 'servicevans',
        loadChildren: () => import('./features/servicevans/servicevans.routes').then(m => m.SERVICEVAN_ROUTES),
        canActivateChild: [AppAuthGuard],
      },

      // Feature: technical-documentation
      {
        path: 'technical-documentation',
        loadChildren: () => import('./features/technical-documentation/technical-documentation.routes').then(m => m.TECHNICAL_DOCUMENATION_ROUTES),
        canActivateChild: [AppAuthGuard],
      },

      // Feature: log-messages
      {
        path: 'log-messages',
        loadChildren: () => import('./features/log-messages/log-messages.routes').then(m => m.LOGMESSAGES_ROUTES),
        canActivateChild: [AccessGuard],
        data: { dsmLicenseNeeded: [DsmLicenseEnum.PRO], permissionNeeded: [SoffLogMessagePermission.LOGMESSAGE_READ], isProductionReady: true },
      },

      // Feature: tickets
      {
        path: 'tickets',
        loadChildren: () => import('@soff/tsc-ui').then(m => m.TSC_ROUTES),
        canActivateChild: [AppAuthGuard],
      },
    ],
  },

  {
    path: 'intro',
    canActivateChild: [AppAuthGuard],
    children: [
      // Intro: start
      {
        path: '',
        loadChildren: () => import('./intro/intro.routes').then(m => m.INTRO_ROUTES),
      },
    ],
  },

  { path: '**', redirectTo: '/' },
];
